
import { Component, Prop, Vue } from "vue-property-decorator";
import t from "@common/src/i18n/t";

@Component({})
export default class StandardFlag extends Vue {
  @Prop({ default: false, type: Boolean })
  showFlag: boolean;
  @Prop({ default: () => t("other.standard—flag-text") })
  text: string;
  @Prop({ default: () => t("other.standard—flag-tips") })
  tipsText: string;
}
